import React, { Component } from 'react';
import RudrakshImg from '../../Assets/Img/rudraksh-pathak-no-background.png';
import DaffodilImg from '../../Assets/Img/daffodil-software.png';
import MicrosoftImg from '../../Assets/Img/microsoft.png';
import MozillaImg from '../../Assets/Img/firefox.png';
import GithubImg from '../../Assets/Img/github.png';
import IbaImg from '../../Assets/Img/iba-award.png';
import StackoverflowImg from '../../Assets/Img/stack-overflow.png';
import NpmImg from '../../Assets/Img/npm.png';
import UnitedAirlinesImg from '../../Assets/Img/united-airlines.png';
import './Body.css';
import Testimonial from './Testimonial';

class Body extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  copyEmail = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText('connect@rudrakshpathak.com').then(() => {
      this.setState({ copied: true });
      setTimeout(() => {
        this.setState({ copied: false });
      }, 2500);
    });
  };

  render() {
    const { copied } = this.state;

    const affiliations = [
      {
        img: UnitedAirlinesImg,
        name: 'United Airlines',
        role: 'Senior Engineer',
        period: '2024 – Present',
        url: 'https://www.united.com/en/us',
        desc: 'Architecting and developing resilient, high-availability aviation software platforms and mission-critical services serving millions of travelers worldwide.',
        tags: ['Distributed Systems', 'AWS', 'Microservices', 'High Availability']
      },
      {
        img: DaffodilImg,
        name: 'Daffodil Software',
        role: 'Technical Lead & Application Architect',
        period: '2016 – 2024',
        url: 'https://www.daffodilsw.com/',
        desc: 'Led cross-functional engineering teams of 15+ developers. Architected enterprise-grade cloud systems, established CI/CD pipelines, and transformed product scalability.',
        tags: ['Application Architecture', 'Node.js', 'AWS', '.NET', 'Team Leadership']
      },
      {
        img: MicrosoftImg,
        name: 'Microsoft',
        role: 'Student Partner',
        period: '2014 - 2015',
        url: 'https://studentpartners.microsoft.com/en-us',
        desc: 'Championed the Women in Tech initiative across regional academic institutions. Conducted workshops on Microsoft Azure, cloud development, and .NET frameworks.',
        tags: ['Cloud Evangelism', 'Azure', '.NET', 'Public Speaking']
      },
      {
        img: MozillaImg,
        name: 'Mozilla',
        role: 'Student Ambassador',
        period: '2013 – 2014',
        url: 'https://www.mozilla.org/en-US/contribute/studentambassadors/',
        desc: 'Spearheaded open-source contribution drives, hackathons, and developer bootcamps promoting web standards and open technology.',
        tags: ['Open Source', 'Web Standards', 'Community Building']
      },
    ];

    const contributions = [
      {
        img: GithubImg,
        name: 'GitHub',
        role: 'Open Source Creator',
        desc: 'Author of open-source SDK wrappers, tools, and developer utilities.',
        url: 'https://github.com/rudrakshpathak'
      },
      {
        img: StackoverflowImg,
        name: 'Stack Overflow',
        role: 'Community Mentor',
        desc: 'Active contributor answering complex engineering & architectural queries.',
        url: 'https://stackoverflow.com/users/3903252/rudraksh-pathak'
      },
      {
        img: NpmImg,
        name: 'npm Registry',
        role: 'Package Author',
        desc: 'Published npm packages and libraries for developers worldwide.',
        url: 'https://www.npmjs.com/~rudrakshpathak'
      },
      {
        img: IbaImg,
        name: 'IndiBlogger',
        role: 'Award-winning Blogger',
        desc: 'Awarded as one of India\'s best teenage tech bloggers at IBA.',
        url: 'https://www.indiblogger.in/iba/2013/'
      },
    ];

    const skills = [
      {
        icon: 'fa-cloud',
        category: 'Cloud & Architecture',
        desc: 'Designing fault-tolerant, elastic systems',
        items: ['AWS', 'Microservices Architecture', 'System Design & Distributed Systems', 'RESTful APIs', 'Event-Driven Architecture']
      },
      {
        icon: 'fa-code',
        category: 'Backend & Full Stack',
        desc: 'Robust engineering and high performance',
        items: ['Node.js & Express', 'C# / .NET Core', 'TypeScript & JavaScript', 'React & Next.js']
      },
      {
        icon: 'fa-database',
        category: 'Databases & DevOps',
        desc: 'Reliability, CI/CD, and data persistence',
        items: ['PostgreSQL & MySQL', 'MongoDB & NoSQL', 'Docker & Containerization', 'CI/CD Pipelines & GitHub Actions', 'Infrastructure as Code']
      },
      {
        icon: 'fa-users',
        category: 'Leadership & Practice',
        desc: 'Mentoring, delivery, and governance',
        items: ['Technical Leadership', 'Mentoring & Team Growth', 'Code Reviews & Quality Standards', 'Agile / Scrum Methodologies', 'Performance Optimization']
      },
    ];

    return (
      <div className="home-container">
        {/* HERO SECTION */}
        <section className="hero-section">
          <div className="hero-grid">
            <div className="hero-copy-col animate-fade-in-up">

              <h1 className="hero-title">
                <span className="hero-greeting-prefix">Hi, I'm</span>
                <span className="hero-name-main text-gradient">Rudraksh Pathak</span>
              </h1>

              <div className="hero-subtitle">
                Engineer <span className="hero-subtitle-dot" aria-hidden="true"></span> Application Architect
              </div>

              <p className="hero-bio">
                10+ years of engineering experience building highly available, fault-tolerant cloud platforms, distributed systems, and leading high-performing engineering teams from conception to global scale.
              </p>
            </div>

            {/* AVATAR COLUMN */}
            <div className="hero-avatar-col animate-fade-in-up delay-2">
              <div className="portrait-wrapper">
                <div className="portrait-frame">
                  <img src={RudrakshImg} alt="Rudraksh Pathak, Senior Software Engineer and Application Architect" className="avatar-img" width="480" height="460" fetchPriority="high" />
                </div>
              </div>

              <div className="hero-social-strip">
                <a href="https://github.com/rudrakshpathak" target="_blank" rel="noopener noreferrer" className="social-pill" title="GitHub">
                  <i className="fa fa-github"></i>
                </a>
                <a href="https://in.linkedin.com/pub/rudraksh-pathak/25/42/239" target="_blank" rel="noopener noreferrer" className="social-pill" title="LinkedIn">
                  <i className="fa fa-linkedin"></i>
                </a>
                <a href="https://twitter.com/rudrapathak" target="_blank" rel="noopener noreferrer" className="social-pill" title="Twitter">
                  <i className="fa fa-twitter"></i>
                </a>
                <a href="https://stackoverflow.com/users/3903252/rudraksh-pathak" target="_blank" rel="noopener noreferrer" className="social-pill" title="Stack Overflow">
                  <i className="fa fa-stack-overflow"></i>
                </a>
                <a href="mailto:connect@rudrakshpathak.com" className="social-pill" title="Email">
                  <i className="fa fa-envelope"></i>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* EXPERIENCE & CAREER TIMELINE */}
        <section className="section-container animate-fade-in">
          <div className="section-header-left">
            <span className="section-eyebrow">Career Journey</span>
            <h2 className="section-title">Experience &amp; Leadership</h2>
            <p className="section-desc">
              A decade of building enterprise-grade platforms, leading engineering teams, and architecting cloud systems.
            </p>
          </div>

          <div className="timeline-container">
            {affiliations.map((item, idx) => (
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                key={idx}
                className="timeline-row"
              >
                <div className="timeline-meta">
                  <span className="timeline-period-badge">{item.period}</span>
                </div>
                <div className="timeline-card">
                  <div className="timeline-card-header">
                    <div className="company-logo-wrap">
                      <img src={item.img} alt={item.name} />
                    </div>
                    <div className="company-info">
                      <h3 className="company-name">{item.name}</h3>
                      <p className="company-role">{item.role}</p>
                    </div>
                    <i className="fa fa-external-link timeline-link-icon"></i>
                  </div>
                  <p className="company-desc">{item.desc}</p>
                  <div className="timeline-tags">
                    {item.tags.map((tag, tIdx) => (
                      <span className="timeline-tag" key={tIdx}>{tag}</span>
                    ))}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </section>

        {/* TECHNICAL EXPERTISE / BENTO GRID */}
        <section className="section-container animate-fade-in">
          <div className="section-header-left">
            <span className="section-eyebrow">Core Competencies</span>
            <h2 className="section-title">Technical Skills &amp; Architecture</h2>
            <p className="section-desc">
              Technologies, architectures, and engineering frameworks leveraged in production systems.
            </p>
          </div>

          <div className="skills-bento-grid">
            {skills.map((group, idx) => (
              <div className="bento-skill-card" key={idx}>
                <div className="bento-card-header">
                  <div className="bento-icon-box">
                    <i className={`fa ${group.icon}`}></i>
                  </div>
                  <div>
                    <h3 className="bento-card-title">{group.category}</h3>
                    <p className="bento-card-subtitle">{group.desc}</p>
                  </div>
                </div>
                <ul className="bento-skill-list">
                  {group.items.map((skill, i) => (
                    <li key={i} className="bento-skill-item">
                      <i className="fa fa-check-circle bento-check"></i>
                      <span>{skill}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* ECOSYSTEM CONTRIBUTIONS */}
        <section className="section-container animate-fade-in">
          <div className="section-header-left">
            <span className="section-eyebrow">Community &amp; Open Source</span>
            <h2 className="section-title">Ecosystem Contributions</h2>
            <p className="section-desc">
              Giving back through open source libraries, developer mentoring, and technical writing.
            </p>
          </div>

          <div className="contributions-grid">
            {contributions.map((item, idx) => (
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                key={idx}
                className="contribution-box"
              >
                <div className="contrib-top">
                  <div className="contrib-logo-wrap">
                    <img src={item.img} alt={item.name} />
                  </div>
                  <i className="fa fa-arrow-up-right fa-external-link contrib-link-icon"></i>
                </div>
                <h4 className="contrib-title">{item.name}</h4>
                <span className="contrib-role-badge">{item.role}</span>
                <p className="contrib-desc">{item.desc}</p>
              </a>
            ))}
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section className="section-container animate-fade-in">
          <div className="section-header-left">
            <span className="section-eyebrow">Endorsements</span>
            <h2 className="section-title">What People Say</h2>
            <p className="section-desc">
              Recommendations from engineering managers, application architects, and delivery leads.
            </p>
          </div>
          <Testimonial />
        </section>

        {/* CONTACT / CTA BAND */}
        <section className="contact-cta-wrapper animate-fade-in">
          <div className="contact-cta-card">
            <div className="contact-cta-content">
              <span className="cta-eyebrow">Let's Connect</span>
              <h2 className="cta-headline">Open to connecting for anything</h2>
              <p className="cta-subtext">
                Say Hello - my inbox is always open.
              </p>
              <div className="cta-action-row">
                <a href="mailto:connect@rudrakshpathak.com" className="btn-cta-primary">
                  <i className="fa fa-envelope-o"></i>
                  <span>connect@rudrakshpathak.com</span>
                </a>
                <button
                  type="button"
                  onClick={this.copyEmail}
                  className="btn-cta-copy"
                >
                  <i className={`fa ${copied ? 'fa-check' : 'fa-clone'}`}></i>
                  <span>{copied ? 'Copied!' : 'Copy Email'}</span>
                </button>
                <a
                  href="https://in.linkedin.com/pub/rudraksh-pathak/25/42/239"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-cta-secondary"
                >
                  <i className="fa fa-linkedin"></i>
                  <span>LinkedIn Profile</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Body;
